import React from 'react';

import PropTypes from 'prop-types';

const RequiredLabel = ({ label }) => (
  <span className="required-label-text">
    {label}
    <span className="required-label-asterisk" aria-hidden="true">*</span>
  </span>
);

RequiredLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default RequiredLabel;
